/* eslint-disable @typescript-eslint/no-require-imports */
import TDR from 'tdr-common';

type VendorObject = {
	logo: string
	color: string
	displayName: string
	imageStyles?: string
}

const vendorMap: Record<string, VendorObject> = {
	auphan: {
		logo: require('../images/poweredBy/logos/auphan.svg'),
		color: '#1A237E',
		displayName: 'Auphan'
	},
	cvent: {
		logo: require('../images/poweredBy/logos/cvent.svg'),
		color: '#00A1DF',
		displayName: 'Cvent'
	},
	eatapp: {
		logo: require('../images/poweredBy/logos/eatapp.svg'),
		color: '#128849',
		displayName: 'Eat App'
	},
	infor: {
		logo: require('../images/poweredBy/logos/infor.svg'),
		color: '#D81820',
		displayName: 'Infor',
		imageStyles: 'right-10'
	},
	inKind: {
		logo: require('../images/poweredBy/logos/inKind.svg'),
		color: '#D81820',
		displayName: 'inKind'
	},
	mrblack: {
		logo: require('../images/poweredBy/logos/mrblack.svg'),
		color: '#292b2f',
		displayName: 'Mr Black'
	},
	oftendining: {
		logo: require('../images/poweredBy/logos/oftendining.svg'),
		color: '#0089CD',
		displayName: 'Often Dining'
	},
	opentable: {
		logo: require('../images/poweredBy/logos/opentable.svg'),
		color: '#DA3743',
		displayName: 'OpenTable'
	},
	resdiary: {
		logo: require('../images/poweredBy/logos/resdiary.svg'),
		color: '#00AEEF',
		displayName: 'ResDiary'
	},
	resy: {
		logo: require('../images/poweredBy/logos/resy.svg'),
		color: '#FF462D',
		displayName: 'Resy'
	},
	rezplus: {
		logo: require('../images/poweredBy/logos/reservationFallback.svg'),
		color: '#2E3192',
		displayName: 'RezPlus'
	},
	sevenrooms: {
		logo: require('../images/poweredBy/logos/sevenrooms.svg'),
		color: '#0ABCC2',
		displayName: 'SevenRooms'
	},
	snappy: {
		logo: require('../images/poweredBy/logos/snappy.svg'),
		color: '#B53797',
		displayName: 'Snappy'
	},
	tock: {
		logo: require('../images/poweredBy/logos/tock.svg'),
		color: '#0F0FC0',
		displayName: 'Tock'
	},
	touchbistro: {
		logo: require('../images/poweredBy/logos/touchbistro.svg'),
		color: '#00A3AD',
		displayName: 'TouchBistro'
	},
	tripleseat: {
		logo: require('../images/poweredBy/logos/tripleseat.svg'),
		color: '#292D43',
		displayName: 'Tripleseat'
	},
	waitlistme: {
		logo: require('../images/poweredBy/logos/reservationFallback.svg'),
		color: '#69C9CD',
		displayName: 'Waitlist Me'
	},
	yelp: {
		logo: require('../images/poweredBy/logos/yelp.svg'),
		color: '#FF1A1A',
		displayName: 'Yelp'
	},
	phone: {
		logo: require('../images/poweredBy/logos/phone.svg'),
		color: '#292b2f',
		displayName: 'Phone'
	},
	email: {
		logo: require('../images/poweredBy/logos/email.svg'),
		color: '#292b2f',
		displayName: 'Email'
	}
};

export const getPlatformDetails = (vendor: TDR.TDR.AlternativePlatform): VendorObject => {
	return vendorMap[vendor] || { logo: '../images/poweredBy/logos/reservationFallback.svg', color: '#292b2f', displayName: 'our partner' };
};

export const getDisplayPhoneNumber = (linkablePhoneNumber: string): string => {
	const cleaned = linkablePhoneNumber.replace(/\s+/g, '').replace(/^tel:/, '');
	const match = cleaned.match(/^\+?(\d{1})(\d{3})(\d{3})(\d{4})$/);

	if (!match) {
		return linkablePhoneNumber;
	}

	return `+${match[1]} ${match[2]}-${match[3]}-${match[4]}`;
};

export const getDisplayEmail = (linkableEmail: string): string => {
	return linkableEmail.replace(/^mailto:/, '');
};